/* eslint-disable object-curly-newline */
import destroy from "app/_shared/events/destroy";
import list from "app/_shared/events/list";
import redirect from "app/_shared/events/redirect";
import forceRedirect from "app/_shared/events/redirect/force";
import back from "app/_shared/events/redirect/back";
import detail from "app/_shared/events/action/detail";
import edit from "app/_shared/events/action/edit";
import submit from "app/_shared/events/action/submit";
import bulk from "app/_shared/events/action/bulk";
import {
  persistChange,
  persistCheck,
  persistOption,
  persistOptions,
  persistScroll,
} from "./persist";

/**
 * Shared Events
 *
 * @type Gaia.AppModule.Events
 */
const sharedEvents = {
  persistChange,
  persistCheck,
  persistScroll,
  edit,
  list,
  redirect,
  forceRedirect,
  persistOptions,
  persistOption,
  submit,
  bulk,
  detail,
  back,
  destroy,
};

export {
  sharedEvents as default,
  persistChange,
  persistCheck,
  persistOptions,
  persistOption,
  persistScroll,
  edit,
  list,
  redirect,
  forceRedirect,
  submit,
  bulk,
  detail,
  back,
  destroy,
};
